import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TimePeriodData } from '../../../../types/timePeriodData'

interface ScoreboardHeaderProps {
	activeSlide: number
	timePeriods: TimePeriodData[]
}

const ScoreboardHeader: FC<ScoreboardHeaderProps> = ({ activeSlide, timePeriods }) => {
	const { t } = useTranslation('pages_saving', { keyPrefix: 'scoreboardHeader' })

	return (
		<div className='text-center'>
			<span className='text-lg font-semibold text-text-dark dark:text-white tracking-wide'>
				{timePeriods[activeSlide]?.title || t('previousPeriod')}
			</span>
			<div className='text-sm text-text-grey-200 dark:text-text-grey-100 mt-1'>
				{timePeriods[activeSlide]?.subtitle}
			</div>
		</div>
	)
}

export default ScoreboardHeader
